
import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for ArtistsCatalog Action/Mutation Types. Use it in   artists/actions.js, artists/mutations.js and the Vuex Host Component 
export const BelieveStatementList = createActionTypeModel('BelieveStatementList');
export const DefaultStatementList = createActionTypeModel('DefaultStatementList');
export const StatementList = createActionTypeModel('StatementList');
export const BelieveStatementDetails = createActionTypeModel('BelieveStatementDetails');
export const DefaultStatementDetails =createActionTypeModel('DefaultStatementDetails');
export const StatementDetails = createActionTypeModel('StatementDetails');
export const StatementPayment=createActionTypeModel('StatementPayment');
export const Log=createActionTypeModel('Log');
export const TaxDeduction=createActionTypeModel('TaxDeduction');
export const RoyaltyStatementVatRate=createActionTypeModel('RoyaltyStatementVatRate');
export const ClOSING_STATEMENT='ClOSING_STATEMENT'


